// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"9144e364","332":"e152523f","716":"f22dac21","782":"b36748f3","806":"4fb3fc27","915":"7874b90b"}[chunkId] + ".chunk.js";
};